import React from 'react';
import { Link } from 'react-router-dom';
import { LiaCoinsSolid } from 'react-icons/lia';
import { useProfile } from '../contexts/ProfileContext';
import './CoinDisplay.css';

const CoinDisplay = ({ floating = false }) => {
  const { coins, loading, user } = useProfile();
  const className = floating ? 'coin-display floating' : 'coin-display';

  if (!user) {
    return null;
  }

  return (
    <Link
      to="/coins"
      className={`${className} coin-display-link header-pill-button`}
      aria-label="Open coin shop"
    >
      <LiaCoinsSolid className="coin-icon" aria-hidden="true" focusable="false" />
      <span className="coin-amount">{coins}</span>
    </Link>
  );
};

export default CoinDisplay; 